import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import fieldTypes from '../formFields.types';

function DynamicAttributePreview({
  configProps: {
    title,
    optional,
    dataType,
    subType,
    fieldId,
  } = {},
  customTables = {},
  isDisplay: parentIsDisplay = false,
  ...rest
}) {
  const projectCustomFields = useSelector((state) => state.projects.customFieldTemplate);
  const ccCustomFields = useSelector((state) => state.costcodes.customFieldTemplate);
  const userCustomFields = useSelector((state) => state.users.customFieldTemplate);
  const equipmentTypes = useSelector((state) => state.equipment.equipmentTypes);
  const customerCustomFields = useSelector((state) => state.customers.customFieldTemplate);

  const ourField = useMemo(() => {
    if (!fieldId || !dataType) return {};
    let fields = [];
    switch (dataType) {
      case 'projects':
        fields = projectCustomFields?.fields ?? [];
        break;
      case 'costcodes':
        fields = ccCustomFields?.fields ?? [];
        break;
      case 'users':
        fields = userCustomFields?.fields ?? [];
        break;
      case 'equipment': {
        const ourType = equipmentTypes.find((type) => (
          type.id === subType
          || (subType === null && type.isDefault)
        ));
        fields = ourType?.customFields?.fields ?? [];
        break;
      }
      case 'customers':
        fields = customerCustomFields?.fields ?? [];
        break;
      default:
        fields = [];
    }
    return fields.find((field) => field.id === fieldId);
  }, [
    fieldId,
    dataType,
    projectCustomFields,
    userCustomFields,
    ccCustomFields,
    equipmentTypes,
    customerCustomFields,
  ]);

  const {
    [ourField?.selectedType]: {
      preview = () => null,
    } = {},
  } = fieldTypes;

  const tableDataType = ourField?.configProps?.dataType;
  const isCustomSavedTableDynamicAttribute = (
    ourField?.selectedType === 'table'
    && tableDataType != null
    && tableDataType in customTables
  );
  const effectiveIsDisplay = isCustomSavedTableDynamicAttribute ? parentIsDisplay : true;

  return preview({
    ...rest,
    customTables,
    isDisplay: effectiveIsDisplay,
    configProps: {
      ...ourField?.configProps ?? {},
      title,
      optional,
      isDynamicAttribute: true,
    },
  });
}

/* eslint-disable react/forbid-prop-types */
DynamicAttributePreview.propTypes = {
  configProps: PropTypes.object,
  customTables: PropTypes.objectOf(PropTypes.object),
  isDisplay: PropTypes.bool,
};

DynamicAttributePreview.defaultProps = {
  configProps: {},
  customTables: {},
  isDisplay: false,
};

export default DynamicAttributePreview;
